import React from 'react';
import { IconSvgProps } from '@models/common';

const LightBulb: React.FC<IconSvgProps> = (props) => {
  const { size = 16, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10 10.2737C10 8.74167 11.002 8.05542 11.6393 6.66223C11.8709 6.15601 12 5.59308 12 5C12 2.79086 10.2091 1 8 1C5.79086 1 4 2.79086 4 5C4 5.59308 4.12907 6.15601 4.36066 6.66223C4.99802 8.05542 6 8.74167 6 10.2737'
        stroke='#F79009'
        strokeLinecap='round'
      />
      <path
        d='M6 12.333H10'
        stroke='#F79009'
        strokeLinecap='round'
      />
      <path
        d='M6.6665 14.333H9.33317'
        stroke='#F79009'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default LightBulb;
